import React from 'react';
import cx from 'classnames';
import _ from 'lodash';
import { Col } from 'react-bootstrap';
import styles from './notifications.module.scss';
import SwitchButton from 'src/components/switchButton/index';
import CommonStyles from '../Styles.module.scss';
import { localizedStrings } from 'src/localization/index.jsx';
import userRoleService from 'src/services/userRoles.service';
import { toast } from 'react-toastify';
import Toast from 'src/components/toast';
class NotificationView extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      preferences: props.preferences 
    };

    this._handleCheckboxChange = this._handleCheckboxChange.bind(this);

    this.localizedCommons = localizedStrings.commons;
    this.localizedCommonActions = this.localizedCommons.actions;
    this.localizatedSettings = localizedStrings.pages.settings;
    this.localizedNotification = this.localizatedSettings.notification;
    this.localizedTransactionalNotifications = this.localizedNotification.transactional_notifications;
    this.localizedTransactionTrigger = this.localizedTransactionalNotifications.transaction_trigger;
    this.localizedCommunicationChannel = this.localizedTransactionalNotifications.communication_channel;
  }

  _handleCheckboxChange(key) {
    const [category, keys] = key.split(".");

    this.setState((prevState) => {
      const selected = _.get(prevState.preferences, key, false);
      const updatedPreferences = {
          ...prevState.preferences,
        [category]: {
          ...prevState.preferences[category],
          [keys]: !selected,
        },
        };

      this.props.updateUserNotification(updatedPreferences);
      return { preferences: updatedPreferences };
    });
}

  _handleSwitchButtonChange(key) {
    var preferences = { ...this.props.preferences, [key]: !this.props.preferences[key]};
    this.props.updateUserNotification(preferences);
  }

  componentDidMount() {
    this.props.fetchUserNotification();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.preferences !== this.props.preferences) {
      this.setState({
        preferences: nextProps.preferences
      });
    }

    if (!nextProps.updating && nextProps.updated) {
      toast(
        <Toast.Sucess
          toast={toast}
          heading={"Success"}
          message={"Updated successfully"}
        />,
        {
          autoClose: 3000,
        }
      );
      this.props.invalidateNotificationUpdate();
    }
  }

  render() {

    return (
      <div className={styles.content}>
        <div className={cx(CommonStyles.selectionView)}>
          <div className={CommonStyles.innerContent}>
            <div className={styles.heading}>{this.localizedNotification.title}</div>
            <div className={styles.notificationCentercontainer}>
              {userRoleService.canShare() &&
                <div className={styles.notificationDiv}>
                  <div className={styles.notifications}>
                    <div> {this.localizedNotification.daily_digest.email.title} </div>
                    <div className={styles.description}>{this.localizedNotification.daily_digest.email.description}</div>
                  </div>
                  <div className={styles.switchButtonContainer}>
                    <SwitchButton
                    
                      id="enabledailydigest"
                      handleCheck={() => this._handleSwitchButtonChange("emailDigestEnabled")}
                      className={styles.switchButton}
                      checked={this.isSelected('emailDigestEnabled')} />
                  </div>
                </div>
              }
              {userRoleService.canShare() && userRoleService.canAccessHub() && <div className={styles.horizontalLine}></div>}
              {userRoleService.canAccessHub() && 
              <div className={styles.streamDigest}>
                <div className={styles.notifications}>
                  <div>{this.localizedNotification.daily_digest.stream.title}</div>
                  <div className={styles.description}>{this.localizedNotification.daily_digest.stream.description}</div>
                </div>
                <div className={styles.switchButtonContainer}>
                  <SwitchButton className={styles.switchButton}
                    id="enablestreamdailydigest"
                    handleCheck={() => this._handleSwitchButtonChange("followerEmailDigestEnabled")}
                    checked={this.isSelected('followerEmailDigestEnabled')}
                  />
                </div>
              </div>}

              {userRoleService.canAccessHub() && <div className={styles.horizontalLine}></div>}
              <div className={styles.streamDigest}>
                <div className={styles.notifications}>
                  <div>{this.localizedNotification.weekly_digest.stream.title}</div>
                  <div className={styles.description}>{this.localizedNotification.weekly_digest.stream.description}</div>
                </div>
                <div className={styles.switchButtonContainer}>
                  <SwitchButton className={styles.switchButton}
                    id="enablestreamWeeklydigest"
                    handleCheck={() => this._handleSwitchButtonChange("weekEmailDigestEnabled")}
                    checked={this.isSelected('weekEmailDigestEnabled')}
                  />
                </div>
              </div>

            </div>

            {userRoleService.canShare() &&
              <span>
                <div className={styles.notifications}>
                  {this.localizedTransactionalNotifications.title}
                </div>

                <div className={styles.description}>{this.localizedTransactionalNotifications.description}</div>
                <Col md={12} className={styles.noPadding}>
                  <div className={styles.border}></div>
                  <div className={styles.emailNotification}>
                    <span className={styles.title}>{this.localizedTransactionTrigger.title}</span>
                    <span>{this.localizedCommunicationChannel.title}</span>
                  </div>

                  <div>
                    {this._renderEventsList()}
                  </div>
                </Col>
              </span>
            }
          </div>
        </div>
      </div>
    );
  }

  _renderEventsList() {
    return (
      <div>
        <div className={styles.eventContainer}>
          <div className={styles.eventsList}>{this.localizedTransactionTrigger.email_opened}</div>
          <div onClick={() => this._handleCheckboxChange("push.emailOpen")} className={styles.userSelection}>
            {this._renderCheckbox('push.emailOpen')}
            <span className={styles.pushNotification}>{this.localizedCommunicationChannel.push_notification}</span>
          </div>
          <div onClick={() => this._handleCheckboxChange("email.emailOpen")} className={styles.userSelection}>
            {this._renderCheckbox('email.emailOpen')}
            <span className={styles.email}>{this.localizedCommunicationChannel.email}</span>
          </div>
        </div>

        <div className={styles.eventContainer}>
          <div className={styles.eventsList}>{this.localizedTransactionTrigger.link_clicked}</div>
          <div onClick={() => this._handleCheckboxChange("push.linkClicked")} className={styles.userSelection}>
            {this._renderCheckbox('push.linkClicked')}
            <span className={styles.pushNotification}>{this.localizedCommunicationChannel.push_notification}</span>
          </div>
          <div onClick={() => this._handleCheckboxChange("email.linkClicked")} className={styles.userSelection}>
            {this._renderCheckbox('email.linkClicked')}
            <span className={styles.email}>{this.localizedCommunicationChannel.email}</span>
          </div>
        </div>

        <div className={styles.eventContainer}>
          <div className={styles.eventsList}>{this.localizedTransactionTrigger.asset_viewed}</div>
          <div onClick={() => this._handleCheckboxChange("push.assetViewed")} className={styles.userSelection}>
            {this._renderCheckbox('push.assetViewed')}
            <span className={styles.pushNotification}>{this.localizedCommunicationChannel.push_notification}</span>
          </div>
          <div onClick={() => this._handleCheckboxChange("email.assetViewed")} className={styles.userSelection}>
            {this._renderCheckbox('email.assetViewed')}
            <span className={styles.email}>{this.localizedCommunicationChannel.email}</span>
          </div>
        </div>

        <div className={styles.eventContainer}>
          <div className={styles.eventsList}>{this.localizedTransactionTrigger.asset_download}</div>
          <div onClick={() => this._handleCheckboxChange("push.assetDownload")} className={styles.userSelection}>
            {this._renderCheckbox('push.assetDownload')}
            <span className={styles.pushNotification}>{this.localizedCommunicationChannel.push_notification}</span>
          </div>
          <div onClick={() => this._handleCheckboxChange("email.assetDownload")} className={styles.userSelection}>
            {this._renderCheckbox('email.assetDownload')}
            <span className={styles.email}>{this.localizedCommunicationChannel.email}</span>
          </div>
        </div>

        <div className={styles.eventContainer}>
          <div className={styles.eventsList}>{this.localizedTransactionTrigger.collection_viewed}</div>
          <div onClick={() => this._handleCheckboxChange("push.collectionViewed")} className={styles.userSelection}>
            {this._renderCheckbox('push.collectionViewed')}
            <span className={styles.pushNotification}>{this.localizedCommunicationChannel.push_notification}</span>
          </div>
          <div onClick={() => this._handleCheckboxChange("email.collectionViewed")} className={styles.userSelection}>
            {this._renderCheckbox('email.collectionViewed')}
            <span className={styles.email}>{this.localizedCommunicationChannel.email}</span>
          </div>
        </div>

        <div className={styles.eventContainer}>
          <div className={styles.eventsList}>
            {this.localizedTransactionTrigger.content_reshared}
          </div>
          <div onClick={() => this._handleCheckboxChange("push.reshare")} className={styles.userSelection}>
            {this._renderCheckbox('push.reshare')}
            <span className={styles.pushNotification}>{this.localizedCommunicationChannel.push_notification}</span>
          </div>
          <div onClick={() => this._handleCheckboxChange("email.reshare")} className={styles.userSelection}>
            {this._renderCheckbox('email.reshare')}
            <span className={styles.email}>{this.localizedCommunicationChannel.email}</span>
          </div>
        </div>

        <div className={styles.eventContainer}>
          <div className={styles.eventsList}>
            {this.localizedTransactionTrigger.lead_captured}
          </div>
          <div onClick={() => this._handleCheckboxChange("push.leadCaptured")} className={styles.userSelection}>
            {this._renderCheckbox('push.leadCaptured')}
            <span className={styles.pushNotification}>{this.localizedCommunicationChannel.push_notification}</span>
          </div>
          <div onClick={() => this._handleCheckboxChange("email.leadCaptured")} className={styles.userSelection}>
            {this._renderCheckbox('email.leadCaptured')}
            <span className={styles.email}>{this.localizedCommunicationChannel.email}</span>
          </div>
        </div>

      </div>
    );
  }

  _renderCheckbox(key) {
    var selected = this.isSelected(key);

    return (
      <i className={
        cx(styles.checkbox, {
          'paperflite-tick-unselected': selected,
          'paperflite-radio-button-unselected': !selected
        })
      } aria-hidden="true"></i>
    );
  }

  isSelected(key) {
    if (!this.props.preferences) {
      return false;
    }

    return _.get(this.state.preferences, key);
  }
}

export default NotificationView;    